<template>
    <div>
        <div style="background-color: #fff;padding: 20px;">
            <div style="display: flex;justify-content:space-between;margin-top: 0px;">
                <div style="width: auto;display: flex;">
                    <el-input size="small" placeholder="ID/名称" clearable v-model="find_value" @keyup.enter.native=""
                        @clear=""></el-input>
                    <el-button size="small" type="primary" style="margin-left: 5px;"
                        @click="get_list(); page = 1">查找</el-button>
                </div>
                <el-button type="primary" size="small" @click="$router.push('create')">+ 新建</el-button>
            </div>
            <div>
                <div class="biaoqian">合集</div>
                <div style="width: 100%;white-space: nowrap;overflow-x: auto;-webkit-overflow-scrolling:touch;padding-bottom: 5px;">
                    <el-button type="primary" size="small" plain @click="add_col">+新建合集</el-button>
                    <el-tag type="info" style="cursor: pointer;" :effect="$route.query.col=='全部'?'dark':'light'"
                        @click="$router.push('?col=全部'+'&colid=0');">
                        全部合集
                    </el-tag>
                    <el-tag type="info" style="cursor: pointer;margin-right: 6px;" v-for="(item,index) in col_list" :key="index" :effect="$route.query.col==item.name?'dark':'light'" closable @close="del_col(item,index)"
                        @click="$router.push('?col='+item.name+'&colid='+item.id);">
                        {{item.name}}
                    </el-tag>
                </div>
            </div>
            <div style="display: flex;flex-wrap: wrap;margin-top: 10px;">
                <div v-for="(item, index) in tplist " :key="index" style="margin: 10px;" class="show-hide">
                    <div style="width: 160px;position: relative;" @click="make_show = true; make_item = item"
                        class="haowu_one">
                        <el-image style="width: 100%;height: 200px;border-radius: 5px;" fit="cover"
                            :src="item.image"></el-image>
                        <div class="tree_other" @click="gotomake(item)">
                            <div style="text-align: center;">
                                <i class="el-icon-scissors" style="font-size:30px;color: #fff;"></i>
                                <div style="color: #fff;font-size: 14px;font-weight: 600;">立即制作</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 3px;">
                        <div style="font-size: 13px;">
                            {{ item.name }}
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            tplist: [],
            find_value: '',
            col_list:[],
            colid:0
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {
        $route(to, from) {
            // 更新currentURL变量
            console.log(to.query)
            // this.colid=to.query.colid
            this.get_list()
            // this.currentURL = to.fullPath;
        }
    },
    // 方法集合
    methods: {
        del_col(item,index){
            console.log(item)
        },
        add_col() {
            this.$prompt('请输入合集名称', '新建合集', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                this.$ajax.post('qhy/tp/col_fc', {name:value}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        this.col_list.unshift(res.data.data)
                    }else{
                        this.$msg.error(res.data.msg);
                    }

                })
            }).catch(() => {
            });
        },
        get_col(){
            this.$ajax.post('qhy/tp/col_fc', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.col_list=res.data.data.data
                }

            })
        },
        gotomake(item) {
            console.log(item)
            this.$router.push('create?id=' + item.id)
        },
        get_list() {
            this.$ajax.post('qhy/tp/tp_list', {colname:this.$route.query.col}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.tplist = res.data.list
                }

            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.get_list()
        this.get_col()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.tree_other {
    display: none;

    position: absolute;
    bottom: 4px;
    top: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 25%);
    border-radius: 5px;
    cursor: pointer;
}

.show-hide:hover .tree_other {
    display: flex;

}
</style>


// WEBPACK FOOTER //
// src/components/User/Tp/list.vue


// WEBPACK FOOTER //
// src/components/User/Tp/list.vue